import { render } from "./OrderMainBillDetail.vue?vue&type=template&id=3c329292&scoped=true&ts=true"
import script from "./OrderMainBillDetail.vue?vue&type=script&lang=ts"
export * from "./OrderMainBillDetail.vue?vue&type=script&lang=ts"

import "./OrderMainBillDetail.vue?vue&type=style&index=0&id=3c329292&lang=sass&scoped=true"
import "./OrderMainBillDetail.vue?vue&type=style&index=1&id=3c329292&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c329292"]])

export default __exports__